(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('message-recus', {
                parent: 'entity',
                url: '/messages',
                title: "Messages",
                sidebarMeta: {
                    icon: 'glyphicon glyphicon-comment',
                    order: 11
                },
                data: {
                    authorities: ['ROLE_RESPONSABLE_ETABLISSEMENT', 'ROLE_ADMIN', 'ROLE_RESPONSABLE', 'ROLE_ASSISTANT', 'ROLE_RESPONSABLE_ASSISTANT', 'ROLE_RESPONSABLE_INSCRIPTION'],
                    pageTitle: 'josdaviApp.activiteAssistant.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/message/messages.html',
                        controller: 'MessageController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('activiteAssistant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
